const idConvertions = (id: number) => {
    return {
        id,
    }
}

export default idConvertions
